import React from 'react'
import { FormTable, TableHeader, TableRow } from '@front/squirtle'

import Header from './Header'
import Row from './Row'

const DuplicateOrders = ({ order_ids }) =>
  <FormTable
    model_name={'order'}
    loadOnMount={false}
    config={{
      populate: [
        'do.commercial_formula',
        'service.contract.formula',
        'source',
        'destination'
      ],
      initial_filter: {},
      forced_filter: {
        order_id: order_ids
      },
    }}
    tableProps={{
      enablePagination: false,
      onRowClick: null,
    }}
  >
    <TableHeader><Header /></TableHeader>
    <TableRow><Row /></TableRow>
  </FormTable>

export default DuplicateOrders
